<template>
  <div class="inventory-wrapper">
    <div v-if="!inventory || !inventory.data || !inventory.data.server || !servers[inventory.data.server]" class="text-center py-5">
      <b-spinner label="Loading..." variant="primary"></b-spinner>
      <p class="text-muted mt-2">Loading inventory...</p>
    </div>
    
    <div v-else class="animated fadeIn">
      <!-- Read-only Alert -->
      <b-alert v-if="servers[inventory.data.server].readonly" show variant="warning" class="mb-3">
        <i class="fa fa-lock"></i> This server is currently in <strong>Read-only</strong> mode. Inventory changes are disabled.
      </b-alert>

      <!-- Inventory Grid -->
      <div class="rounded shadow-sm border" style="min-height: 500px;">
         <ItemRecords 
            :records="inventory.data.data" 
            :readonly="servers[inventory.data.server].readonly" 
            :server="inventory.data.server"
         />
      </div>
    </div>
  </div>
</template>

<script>
  import Servers from '../../../_servers'
  import ItemRecords from './ItemRecords'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Inventory',
    components: {
      ItemRecords
    },
    props: {
      username: { type: String, required: true },
      server: { type: String, required: true }
    },
    computed: mapGetters({
      inventory: 'allInventory'
    }),
    data () {
      return {
        servers: Servers
      }
    },
    watch: {
      username: 'fetchData',
      server: 'fetchData'
    },
    created () {
      this.fetchData()
    },
    methods: {
      fetchData() {
        if (this.username && this.server) {
          this.emit('getInventory', {
            username: this.username, 
            server: this.server
          })
        }
      }
    }
  }
</script>
